import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardBody,
  CardHeader,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap";
import axios from "../../../utills/api";
import { toast } from "react-toastify";

const UpcomingActivities = () => {
  const [tasks, setTasks] = useState([]);

  useEffect(() => {
    const fetchTasks = async () => {
      try {
        const res = await axios.get("/task");
        console.log("✅ Task Data:", res.data);

        const data = Array.isArray(res.data) 
        ? res.data 
        : Array.isArray(res) 
          ? res 
          : [];
        console.log("✅ Extracted bookings data:", data);
        setTasks(data);
      } catch (error) {
        console.error("❌ Error fetching tasks:", error);
        toast.error("Failed to fetch tasks");
        setTasks([]);
      }
    };
    fetchTasks();
  }, []);

  const getPriorityBadge = (priority) => {
    switch (priority) {
      case "High":
        return <span className="badge bg-danger-subtle text-danger">{priority}</span>;
      case "Medium":
        return <span className="badge bg-warning-subtle text-warning">{priority}</span>;
      case "Low":
        return <span className="badge bg-success-subtle text-success">{priority}</span>;
      default:
        return <span className="badge bg-secondary-subtle text-secondary">{priority}</span>;
    }
  };

  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return {
      day: date.getDate(),
      month: date.toLocaleString("en-US", { month: "short" }),
    };
  };

  // Random soft background colors
  const colorClasses = ["bg-primary", "bg-success", "bg-warning", "bg-info", "bg-danger", "bg-secondary"];

  return (
    <React.Fragment>
      <Col xl={6}>
        <Card style={{height:"434px"}}>
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Upcoming Activities</h4>
            <div className="flex-shrink-0">
              <UncontrolledDropdown className="card-header-dropdown" direction="start">
                <DropdownToggle className="text-reset dropdown-btn" tag="a" role="button">
                  <span className="text-muted fs-18">
                    <i className="mdi mdi-dots-vertical"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu dropdown-menu-end">
                  <DropdownItem>Edit</DropdownItem>
                  <DropdownItem>Remove</DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </CardHeader>

          <CardBody className="card-body pt-0">
            <ul className="list-group list-group-flush border-dashed">
              {tasks.map((task, key) => {
                const { day, month } = formatDate(task.dueDate);
                const assignedList = Array.isArray(task.assignedTo) ? task.assignedTo : [];
                const assignedCount = assignedList.length;

                return (
                  <li className="list-group-item ps-0" key={task._id}>
                    <Row className="align-items-center g-3">
                      {/* Date box */}
                      <div className="col-auto">
                        <div className="avatar-sm p-1 py-2 h-auto bg-light rounded-3">
                          <div className="text-center">
                            <h5 className="mb-0">{day}</h5>
                            <div className="text-muted">{month}</div>
                          </div>
                        </div>
                      </div>

                      {/* Task details */}
                      <div className="col">
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted fs-14">{task.department}</span>
                          {getPriorityBadge(task.priority)}
                        </div>
                        <Link to="#" className="text-reset fs-15 fw-semibold mb-0">
                          {task.task}
                        </Link>
                      </div>

                      {/* Assigned info */}
                      <div className="col-sm-auto">
                        <div className="avatar-group">
                          {assignedList.map((member, idx) => {
                            const firstLetter = member.charAt(0).toUpperCase();
                            const color = colorClasses[idx % colorClasses.length];
                            return (
                              <div className="avatar-group-item" key={idx}>
                                <div className="avatar-xxs">
                                  <span
                                    className={`avatar-title rounded-circle ${color} text-white fw-bold`}
                                    title={member}
                                  >
                                    {firstLetter}
                                  </span>
                                </div>
                              </div>
                            );
                          })}

                          {/* Always show counter */}
                          <div className="avatar-group-item">
                            <div className="avatar-xxs">
                              <span className="avatar-title rounded-circle bg-light text-dark fw-semibold">
                                {assignedCount}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </Row>
                  </li>
                );
              })}
            </ul>

            {/* Footer */}
            <div className="align-items-center mt-2 row g-3 text-center text-sm-start">
              <div className="col-sm">
                <div className="text-muted">
                  Showing <span className="fw-semibold">{tasks.length}</span> of{" "}
                  <span className="fw-semibold">{tasks.length}</span> Results
                </div>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default UpcomingActivities;
